<template>
  <v-card class="main-container">
    <v-card-text>
      <div v-if="GETTERS_LOGIN">
        <v-list class="d-flex align-center justify-start">
          <v-list-item>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              single-line
              x-small
              label="поиск:"
              color="#15336d"
            ></v-text-field>
          </v-list-item>
        </v-list>

        <v-data-table
            :style="{color: $mainColor}"
            :headers="headers"
            :items="(search_data.length > 0 ? search_data : data)"
            item-key="id"
            dense
            :loading="preloaderYet"
            :loading-text="$t('User.loading_orders')"
            :items-per-page="100"
            :footer-props="{
                itemsPerPageOptions: [100, 500, -1],
                itemsPerPageText: 'кол-во на стр.:',
            }"
        >
          <template v-slot:body="{ items, isSelected, select}">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="row_classes(item)" style="cursor: pointer;" @click="openProposalInfo(item.id)">
                <td v-for="header in headers">
                  <span v-if="header['value'] == 'organization'">
                        {{ item['organization_id'] == 134 ? 'other : ' + item['other_org_descr'] : item['organization'] }}
                  </span>
                  <span v-else>
                        {{ item[header['value']] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

      </div>
    </v-card-text>

  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Users',

  components: {},

  data() {
    return {

      headers: [
        { text: 'ID', align: 'start', sortable: true, value: 'id'},
        { text: 'ФИО', sortable: true, value: 'fio'},
        { text: 'Организация', sortable: true, value: 'organization'},
        { text: 'e-mail', sortable: true, value: 'email'},
        { text: 'phone', sortable: true, value: 'phone_number'},
      ],

      data: [],
      search_data: [],

      search: '',
      preloaderYet: false,

      call_id: null,
    };
  },

  async beforeMount() {
    this.loadReference();
  },

  methods:{
    ...mapActions([
      'LOAD_PROFILE_LIST',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      'SHOW_USER_CARD',
    ]),

    loadReference() {
      this.UPDATE_OVERLAY(true)
      this.preloaderYet = true
      this.LOAD_PROFILE_LIST({type: 'all'})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          this.preloaderYet = false
          this.data = res;
          this.make_search()
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
          this.preloaderYet = false
        });
    },

    openProposalInfo(profile_id){
        this.call_id = new Date()
        this.SHOW_USER_CARD({
          'profile_id' : profile_id,
          'call_id': this.call_id
        })
    },
    

    row_classes(item) {
      if(item.is_active == false)
        return "gray_bg";
      else
          return "";
    },

    make_search(){
      if (this.search.length === 0) {
        this.search_data = []
      }
      else{
        this.search_data = this.data.filter(item => {
          var f1 = false, f2 = false, f3 = false, f4 = false, f5 = false
          if (item.fio !== undefined && item.fio !== null) {
            f1 = item.fio.toLowerCase().includes(this.search.toLowerCase())
          }
          if (item.organization !== undefined && item.organization !== null) {
            f2 = item.organization.toLowerCase().includes(this.search.toLowerCase())
          }
          if (item.email !== undefined && item.email !== null) {
            f3 = item.email.toLowerCase().includes(this.search.toLowerCase())
          }
          if (item.id !== undefined && item.id !== null) {
            f4 = item.id == this.search
          }
          if (item.phone_number !== undefined && item.phone_number !== null) {
            f5 = item.phone_number.includes(this.search)
          }
          return f1 || f2 || f3 || f4 || f5
        })
      }
    },
  },

  computed: mapGetters([
    'GETTERS_LOGIN',
    'GETTERS_NEED_RELOAD_CLOSE_USER',
  ]),

  watch: {
    search(val) {
      this.make_search()
    },

    GETTERS_NEED_RELOAD_CLOSE_USER(val){
      if(val && val == this.call_id){
          this.loadReference()
      }
    },
  }

};
</script>
